module.exports = __webpack_public_path__ + "static/media/udemy.9f38217a.png";